import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  isVisibleNavBar: WritableSignal<boolean> = signal(true);
  isVisibleSidebar: WritableSignal<boolean> = signal(true);
  isVisiblePlatformTopBar: WritableSignal<boolean> = signal(false);

  toggleSidebar(): void {
    this.isVisibleSidebar.set(!this.isVisibleSidebar());
  }

  showPlatformTopBar(): void {
    this.isVisiblePlatformTopBar.set(true);
    this.isVisibleNavBar.set(false);
  }

  hidePlatformTopBar(): void {
    this.isVisiblePlatformTopBar.set(false);
    this.isVisibleNavBar.set(true);
  }
}